import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  AppCard,
  AppInput,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalOfficeEmergencyAndPotentialEnvironmentalAspectsCard(
  props
) {
  const { values, setFieldValue, motive, environmentalAffection } = props;
  const [totalSeverity, setTotalSeverity] = useState();
  const [evaluationText, setEvaluationText] = useState();
  const [probabilityOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="low" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="medium" />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="high" />
      ),
      value: 2,
    },
  ]);
  const [peopleAffectionsOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no.people" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="minor" />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="people.admission" />
      ),
      value: 2,
    },
  ]);
  const [environmentalAffectionOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no.environmental" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="minor.environmental"
        />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-comsaEnvironmental"
          name="high.environmental"
        />
      ),
      value: 2,
    },
  ]);

  useEffect(() => {
    if (
      values?.peopleAffections !== undefined &&
      values?.peopleAffections !== null &&
      values?.environmentalAffection !== undefined &&
      values?.environmentalAffection !== null
    ) {
      setTotalSeverity(
        values?.peopleAffections + 1 + values?.environmentalAffection + 1
      );
    } else
      setTotalSeverity(
        <Translator file="module-comsaEnvironmental" name="evaluate.severity" />
      );
  }, [values]);

  useEffect(() => {
    if (values?.probability !== undefined && values?.probability !== null) {
      if (Number.isInteger(totalSeverity)) {
        if (
          values?.probability + 1 + totalSeverity > 6 ||
          (totalSeverity === 6 && values?.probability + 1 === 3)
        ) {
          setEvaluationText(
            <Translator file="module-comsaEnvironmental" name="significant" />
          );
        } else {
          setEvaluationText(
            <Translator
              file="module-comsaEnvironmental"
              name="not-significant"
            />
          );
        }
      } else {
        setEvaluationText(
          <Translator
            file="module-comsaEnvironmental"
            name="evaluate.severity"
          />
        );
      }
    } else {
      setEvaluationText(
        <Translator
          file="module-comsaEnvironmental"
          name="missing.assessments"
        />
      );
    }
  }, [values, totalSeverity]);

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="reason" />:
          </div>
          <div>
            <b>{motive}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator
              file="module-comsaEnvironmental"
              name="environmental.impact"
            />
            :
          </div>
          <div>
            <b>{environmentalAffection}</b>
          </div>
        </div>
      </div>
      <div className="input-block">
        <div className="line">
          <AppSingleSelect
            options={probabilityOptions}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="probability.p"
              />
            )}
            value={values?.probability}
            onChange={(opt) => setFieldValue('probability', opt)}
            isClearable
          />
          <AppSingleSelect
            options={peopleAffectionsOptions}
            title={`${ReactDOMServer.renderToString(
              <Translator file="module-comsaEnvironmental" name="severity" />
            )} / ${ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="impact.on.people"
              />
            )}`}
            value={values?.peopleAffections}
            onChange={(opt) => setFieldValue('peopleAffections', opt)}
            isClearable
          />
        </div>
        <div className="line">
          <AppSingleSelect
            options={environmentalAffectionOptions}
            title={`${ReactDOMServer.renderToString(
              <Translator file="module-comsaEnvironmental" name="severity" />
            )} / ${ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="impact.on.environment"
              />
            )}`}
            value={values?.environmentalAffection}
            onChange={(opt) => setFieldValue('environmentalAffection', opt)}
            isClearable
          />
          <AppInput
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="total.severity.s"
              />
            )}
            value={totalSeverity}
            isReadOnly
          />
        </div>
      </div>
      <div className="score-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="evaluation" />:
          </div>
          <div
            className={
              evaluationText ===
              <Translator file="module-comsaEnvironmental" name="significant" />
                ? 'text-danger'
                : evaluationText ===
                  (
                    <Translator
                      file="module-comsaEnvironmental"
                      name="not-significant"
                    />
                  )
                ? 'text-warning'
                : ''
            }
          >
            <b>{evaluationText}</b>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled(AppCard)`
  .card-body {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .info-block,
  .input-block,
  .score-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0.5rem;
  }

  .info-block,
  .score-block {
    text-align: center;
    .line {
      color: ${colors.primaryLight};
      span:first-child {
        color: #000;
        width: 180px;
        display: inline-block;
      }
    }
  }
  .info-block {
    @media (min-width: 1300px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .input-block {
    .line {
      flex-wrap: wrap;

      & > * {
        margin-bottom: 5px;
      }
      @media (min-width: 1300px) {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        & > * {
          width: calc(50% - 5px);
          margin-top: 5px;
        }
      }
    }
  }
  .score-block {
    flex-direction: column;
    justify-content: center;
  }
  h3 {
    font-weight: normal;
    color: ${colors.primaryLight};
  }
  h3 {
    font-weight: normal;
    color: ${colors.primaryLight};
  }
  & > div {
    border-right: 1px solid ${colors.grey300};
  }
  h3 {
    font-size: 13px;
    color: $colors.primary;
    margin: 0 0 6px 0;
    font-weight: bold;
  }
  h4 {
    font-size: 10px;
    color: $primary;
    text-transform: uppercase;
  }
`;
